<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Token } from '@Shelly/shelly-design-system';
	import { capFirstChar, conditionsFunc } from '../../../../../../../helpers/utilities';
	import {
		DO_WIZARD_STEPS_INDEXES,
		SCENE_ACTIONS_WITH_DELAY_OPTION,
	} from '../helpers/do-wizard-helpers';
	import CustomDynamicInput from 'src/components/CustomDynamicInput.svelte';

	export let sceneData: any;

	const onIncrementDecrementDelay = (value) => {
		sceneData[selectedDelayType].delay.value = value;
		sceneData.isValid = true;
	};

	$: selectedDelayType = SCENE_ACTIONS_WITH_DELAY_OPTION[sceneData.selectedAction];
	$: error = conditionsFunc(sceneData[selectedDelayType].delay.value, false, true)
		? $format('value_must_be_valid_equal_or_greater_than_zero', {
				default: 'Value must be a valid number and equal or greater than 0.',
			})
		: undefined;

	let inputHandler = (e) => {
		sceneData.validStepIndex = DO_WIZARD_STEPS_INDEXES.DELAY_STEP;
		if (conditionsFunc(e.target.value, false, true)) {
			sceneData.isValid = false;
		} else {
			sceneData.isValid = true;
		}
		sceneData[selectedDelayType].delay.value = e.target.value;
	};

	let minusFunction = () =>
		onIncrementDecrementDelay(
			!error && +sceneData[selectedDelayType].delay.value > 0
				? +sceneData[selectedDelayType].delay.value - 1
				: 0,
		);

	let plusFunction = () =>
		onIncrementDecrementDelay(!error ? +sceneData[selectedDelayType].delay.value + 1 : 0);
</script>

<Text element="h2" class="mb-s">{$format('collapse_title_delay_action')}</Text>
<Text styleType="body-small" class="mb-s">
	{$format('action_delay', {
		values: {
			value_and_units: $format(
				`delay_units_${sceneData[selectedDelayType].delay.units === 'sec' ? 'seconds' : 'minutes'}`,
				{
					values: { n: error ? 0 : sceneData[selectedDelayType].delay.value },
				},
			),
		},
	})}
</Text>

<div class="d-flex flex-wrap mt-s">
	<CustomDynamicInput
		additionalContainerClass="mb-sm-s"
		additionalInputAttributes={{
			min: 0,
			max: 1440,
			icon: 'fas fa-clock',
		}}
		disabledMinusBtn={+sceneData[selectedDelayType].delay.value <= 0}
		bind:value={sceneData[selectedDelayType].delay.value}
		bind:error
		bind:inputHandler
		bind:minusFunction
		bind:plusFunction
	/>

	<div class="d-flex align-items-start">
		<Token
			id="token-36tmrg0"
			size="m"
			class="ml-s"
			title={capFirstChar($format('select_units_seconds'))}
			selected={sceneData[selectedDelayType].delay.units === 'sec'}
			on:click={() => {
				sceneData[selectedDelayType].delay.units = 'sec';
			}}
		/>

		<Token
			id="token-tj3uzs6"
			size="m"
			class="ml-s"
			title={capFirstChar($format('select_units_minutes'))}
			selected={sceneData[selectedDelayType].delay.units === 'min'}
			on:click={() => {
				sceneData[selectedDelayType].delay.units = 'min';
			}}
		/>
	</div>
</div>
